import { useMemo } from "react";
import { useSelector } from "react-redux";

import { EDITABLE_ERROR_CODES } from "@/config/app-constant";
import { RootState } from "@/store/root-reducer";

export const useQuoteDisabled = (): boolean => {
  const quoteErrorCode = useSelector(
    (state: RootState) => state.quote.quoteErrorCode
  );
  return useMemo(() => {
    return quoteErrorCode
      ? EDITABLE_ERROR_CODES.includes(quoteErrorCode)
      : false;
  }, [quoteErrorCode]);
};
